import Image from 'next/image';

import { Container, SectionText } from '@/atoms';
import { PriceDetailCard } from '@/organisms';

import type { FunctionComponent } from 'react';
import type { TypePriceDetailProps } from './types';

/**
 * PriceDetail
 */
export const PriceDetail: FunctionComponent<TypePriceDetailProps> = ({
  className = '',
  backgroundColorBottom,
  backgroundColorBottomMobile,
  backgroundColorTop,
  backgroundColorTopMobile,
  caption,
  cardProps,
  cutLevel = 50,
  cutLevelMobile = 50,
  desc,
  textColor,
  title,
  id,
}: TypePriceDetailProps) => (
  <Container
    id={id}
    backgroundColorBottom={backgroundColorBottom}
    backgroundColorTopMobile={backgroundColorTopMobile}
    backgroundColorTop={backgroundColorTop}
    backgroundColorBottomMobile={backgroundColorBottomMobile}
    cutLevel={cutLevel === null ? 50 : cutLevel}
    cutLevelMobile={cutLevelMobile === null ? 50 : cutLevel}
    className={`flex  flex-col gap-5 md:flex-row md:gap-16 ${className}`}
  >
    <SectionText
      title={title}
      desc={desc}
      direction="column"
      textAlign="start"
      variant={textColor}
      caption={caption}
      className="w-full justify-center"
    />
    <div className="md:w-full md:max-w-[500px]">
      <div className="relative left-3 top-7 z-10 h-[56px] w-[56px]">
        <Image
          src="/assets/img/logo/logo_negativo.svg"
          layout="fill"
          objectFit="contain"
          alt="Logo BeCasa"
        />
      </div>
      <PriceDetailCard {...cardProps} />
    </div>
  </Container>
);

PriceDetail.displayName = 'PriceDetail';
